<div class="rts-blog-area rts-section-gap bg-secondary">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="title-area text-center">
                    <span> {{"MENU.POSTS" |translate }}</span>
                    <h2 class="title">{{"POSTS.DESC" | translate }}</h2>
                </div>
            </div>
        </div>
        <div class="g-5 mt--20">
            <div *ngIf="LatestPosts().length > 0" appSwiper [swiperOptions]="swiperOptions()" 
                class="mySwiperh1_blog">
                <div class="swiper-wrapper">
                    @for(post of LatestPosts(); track $index){

                    <div class="swiper-slide">
                        <div class="single-blog-one-wrapper">
                            <div class="thumbnail">
                                <img [src]="post.image" alt="business_Blog" style="height: 350px;">
                                <div class="blog-badge">
                                    <span>{{post.publishedDate | date:'dd-MM-yyyy'}}</span>
                                </div>
                            </div>
                            <div class="blog-content">
                                <!-- <p><span>{{post.title}}</span></p> -->
                                <a [routerLink]="['/article-details',post.id]">
                                    <h5 class="title">
                                        {{ post.title | slice:0:60 }}{{ post?.title?.length! > 60 ? '...' : '' }}
                                    </h5>
                                </a>
                                <a class="rts-read-more btn-primary" [routerLink]="['/article-details',post.id]"><i
                                        class="bi bi-arrow-right"></i>{{"COMMON.MORE THAN" | translate }}</a>
                            </div>
                        </div>
                    </div>
                    }
                </div>
                
                <div class="swiper-pagination"></div>

                <!-- Navigation buttons -->
                <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div>
            </div>
        </div>
    </div>
</div>